import { useState } from 'react';
import { useRegister } from '@refinedev/core';
import { Link } from 'react-router';
import { AuthShell } from '@/components/AuthShell';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface BootstrapVariables {
  email: string;
  password: string;
  token: string;
}

export function Bootstrap() {
  const { mutate: register, isPending } = useRegister<BootstrapVariables>();
  const [token, setToken] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  return (
    <AuthShell title="Bootstrap admin" subtitle="One-shot first-admin setup">
      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          setError(null);
          register(
            { email, password, token },
            {
              onSuccess: (res) => {
                if (!res?.success) {
                  setError(res?.error?.message ?? 'Bootstrap failed');
                }
              },
            },
          );
        }}
      >
        <div className="space-y-2">
          <Label htmlFor="token">Bootstrap token</Label>
          <Input
            id="token"
            type="password"
            autoComplete="off"
            required
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder="INITIAL_ADMIN_TOKEN"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input
            id="password"
            type="password"
            autoComplete="new-password"
            minLength={8}
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        {error && <p className="text-sm text-destructive">{error}</p>}
        <Button type="submit" className="w-full" disabled={isPending}>
          {isPending ? 'Creating…' : 'Create admin'}
        </Button>
      </form>
      <div className="text-center text-xs text-muted-foreground">
        <Link to="/login" className="underline underline-offset-2 hover:text-foreground">
          Back to sign in
        </Link>
      </div>
    </AuthShell>
  );
}
